export const getWordCount = text => text.split(/\s+/).length;


export const WordCountMinValidator = ([text, minLength]) => {
  const wordCount = getWordCount(text);
  return wordCount >= minLength;
}